import * as React from 'react';
import { FC } from 'react';

interface SchemaInterface {
  type: string;
  name?: string;
  url?: string;
  description?: string;
  logo?: string;
  email?: string;
  telephone?: string;
  streetAddress?: string;
  addressLocality?: string;
  postalCode?: string;
}

const SchemaLocalBusiness: FC<SchemaInterface> = (props) => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': props.type,
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'NO',
    },
  };

  if (props.name) {
    Object.assign(structuredData, { name: props.name });
  }

  if (props.url) {
    Object.assign(structuredData, { url: props.url });
  }

  if (props.description) {
    Object.assign(structuredData, { description: props.description });
  }

  if (props.logo) {
    Object.assign(structuredData, { logo: props.logo });
  }

  if (props.email) {
    Object.assign(structuredData, { email: props.email });
  }

  if (props.telephone) {
    Object.assign(structuredData, { telephone: props.telephone });
  }

  /* Address */
  if (props.streetAddress) {
    Object.assign(structuredData.address, {
      streetAddress: props.streetAddress,
    });
  }

  if (props.addressLocality) {
    Object.assign(structuredData.address, {
      addressLocality: props.addressLocality,
    });
  }

  if (props.postalCode) {
    Object.assign(structuredData.address, { postalCode: props.postalCode });
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(structuredData),
      }}
    />
  );
};
export default SchemaLocalBusiness;
